import { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { api } from "../services/api";
import { Link } from "react-router-dom";

const AdminPayments = () => {
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [sortDir, setSortDir] = useState("desc");
  const limit = 20;

  const fetchData = async (pageToLoad = 1) => {
    const query = new URLSearchParams({
      page: pageToLoad,
      limit,
      ...(search && { q: search }),
      sort_by: sortBy,
      sort_dir: sortDir,
    }).toString();

    const res = await api.get(`/api/admin/payments/list?${query}`);
    setPayments(res.data.payments);
    setPage(res.data.page);
    setTotal(res.data.total);
  };

  useEffect(() => {
    fetchData();
  }, [sortBy, sortDir]);

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir(sortDir === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortDir("asc");
    }
  };

  const totalPages = Math.ceil(total / limit);

  const columns = [
    { label: "Date", field: "created_at" },
    { label: "User", field: "user" },
    { label: "Email", field: "email" },
    { label: "Amount", field: "amount_usd" },
    { label: "Method", field: "provider" },
    { label: "Reference", field: "payment_reference" },
    { label: "Status", field: "status" },
  ];

  return (
    <Box sx={{
      backgroundImage: 'url("/assets/bg-pitchest.jpg")',
      backgroundSize: "cover",
      minHeight: "100vh",
      px: 2,
      py: 6,
    }}>
      <Box
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          borderRadius: 4,
          padding: { xs: 2, md: 4 },
          color: "white",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h5">💸 Payments</Typography>
          <Link to="/admin" style={{ color: "#90caf9", fontWeight: "bold" }}>⬅ Back</Link>
        </Box>

        <Typography variant="body2" sx={{ mb: 2 }}>
          Total: {total} — Page {page} of {totalPages}
        </Typography>

        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") fetchData(1);
            }}
            placeholder="Search name, email..."
            style={{
              padding: "6px 10px",
              backgroundColor: "#222",
              color: "#fff",
              border: "1px solid #7e57c2",
              borderRadius: "4px"
            }}
          />
          <Button
            variant="outlined"
            onClick={() => fetchData(1)}
            size="small"
            sx={{ ml: 1 }}
          >
            🔍 Search
          </Button>
        </Box>

        <Box sx={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", color: "white" }}>
            <thead>
              <tr>
                {columns.map((col, idx) => (
                  <th
                    key={idx}
                    onClick={() => handleSort(col.field)}
                    style={{
                      padding: "8px",
                      backgroundColor: "#34163A",
                      cursor: "pointer",
                    }}
                  >
                    {col.label} {sortBy === col.field && (sortDir === "asc" ? "▲" : "▼")}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {payments.map((p, idx) => (
                <tr key={p.id} style={{ backgroundColor: idx % 2 === 0 ? "#5E2F6E" : "transparent" }}>
                  <td style={{ padding: "8px", textAlign:"center" }}>{new Date(p.created_at).toLocaleString()}</td>
                  <td style={{ padding: "8px", textAlign:"center"  }}>{p.user?.first_name} {p.user?.last_name}</td>
                  <td style={{ padding: "8px", textAlign:"center"  }}>{p.user?.email}</td>
                  <td style={{ padding: "8px", textAlign:"center"  }}>${p.amount_usd}</td>
                  <td style={{ padding: "8px", textAlign:"center"  }}>{p.provider}</td>
                  <td style={{ padding: "8px", textAlign:"center"  }}>{p.payment_reference}</td>
                  <td
                    style={{
                      padding: "8px",
                      textAlign: "center",
                      color: p.status === "completed" ? "#4caf50" : "#fff",
                      fontWeight: p.status === "completed" ? "bold" : "normal",
                    }}
                  >
                    {p.status}
                  </td>
                </tr>
              ))}
              {payments.length === 0 && (
                <tr>
                  <td colSpan={columns.length} style={{ padding: "16px", textAlign: "center", backgroundColor: "#452654" }}>
                    No data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Box>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="outlined" disabled={page === 1} onClick={() => fetchData(page - 1)}>⬅ Prev</Button>
          <Button variant="outlined" disabled={page === totalPages || total === 0} onClick={() => fetchData(page + 1)}>Next ➡</Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminPayments;